"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvVariables = void 0;
const parse_data_url_1 = __importDefault(require("parse-data-url"));
const utils_1 = require("../../utils");
function decodeJson(json) {
    try {
        const decoded = JSON.parse(json);
        if (decoded && typeof decoded === 'object') {
            return decoded;
        }
    }
    catch {
        // passthru
    }
    return {};
}
function decodeHttpEnv(header) {
    if (header.startsWith('data:')) {
        const parsed = (0, parse_data_url_1.default)(header);
        if (parsed && parsed.contentType === 'application/json') {
            const data = parsed.toBuffer().toString('utf-8');
            return decodeJson(data);
        }
        return {}; // unsupported data-uri
    }
    return decodeJson(header);
}
function getEnvVariables(req) {
    (0, utils_1.assertServerEnv)('getEnvVariables');
    const headerName = (process.env.HTTP_ENV_HEADER || '').toLowerCase();
    if (headerName && req) {
        const header = req.headers[headerName];
        const httpEnv = decodeHttpEnv(header || '');
        return { ...process.env, ...httpEnv };
    }
    return { ...process.env };
}
exports.getEnvVariables = getEnvVariables;
//# sourceMappingURL=getEnvVariables.js.map